module.exports = __webpack_public_path__ + "h5/img/dizhi@2x.7f0e739e.png";